/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `RegistrationSelectField` for the Caintra Connect frontend.
 * @module components/AppointmentRegistrationSections/shared/RegistrationSelectField
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import Select from "react-select";
import {
  getSelectedOption,
  getSelectStylesWithError,
} from "../../../utils/common";

const RegistrationSelectField = ({
  fieldKey,
  label,
  placeholder,
  options,
  value,
  onChange,
  getFieldValidation,
  missingRequiredFields,
  styles,
  getSelectedOptionFn = getSelectedOption,
  selectStylesFn = getSelectStylesWithError,
  className = "select__control",
  inputGroupClassName,
  ...selectProps
}) => (
  <div className={inputGroupClassName || styles.inputGroup}>
    <label className={styles.inputLabel}>
      {label}
      {missingRequiredFields &&
        Object.hasOwn(missingRequiredFields, fieldKey) && (
          <span className={styles.required}> *</span>
        )}
    </label>
    <Select
      value={getSelectedOptionFn(options, value)}
      options={options}
      placeholder={placeholder}
      styles={selectStylesFn(
        getFieldValidation && getFieldValidation(fieldKey),
      )}
      className={className}
      onChange={onChange}
      {...selectProps}
    />
  </div>
);

export default RegistrationSelectField;
